import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModalModule, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';

import { IconComponent } from './components/icon/icon.component';
import { SocialGlyphComponent } from './components/social-glyph/social-glyph.component';
import { BrandComponent } from './components/brand/brand.component';
import { BusinessLogoComponent } from './components/business-logo/business-logo.component';
import { StampSlotComponent } from './components/stamp-slot/stamp-slot.component';
import { CardBackComponent } from './components/card-back/card-back.component';
import { CardFrontComponent } from './components/card-front/card-front.component';
import { SwitchComponent } from './components/switch/switch.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ToastStackComponent } from './components/toast-stack/toast-stack.component';
import { BrandLoaderComponent } from './components/brand-loader/brand-loader.component';
import { ModalFrameComponent } from './components/modal-frame/modal-frame.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { LegalPanelComponent } from './components/legal-panel/legal-panel.component';
import { ColorFieldComponent } from './components/color-field/color-field.component';
import { ShapePickerComponent } from './components/shape-picker/shape-picker.component';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { LogoPickerComponent } from './components/logo-picker/logo-picker.component';
import { LocationMapComponent } from './components/location-map/location-map.component';
import { BusinessPreviewComponent } from './components/business-preview/business-preview.component';
import { NearbyCardComponent } from './components/nearby-card/nearby-card.component';
import { ScheduleEditorComponent } from './components/schedule-editor/schedule-editor.component';
import { SocialEditorComponent } from './components/social-editor/social-editor.component';
import { LocationFieldsComponent } from './components/location-fields/location-fields.component';
import { ProcessScreenComponent } from './components/process-screen/process-screen.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { MapArtComponent } from './components/map-art/map-art.component';
import { IdentityFieldsComponent } from './components/identity-fields/identity-fields.component';
import { InactiveBannerComponent } from './components/inactive-banner/inactive-banner.component';

const COMPONENTS = [
  IconComponent,
  SocialGlyphComponent,
  BrandComponent,
  BusinessLogoComponent,
  StampSlotComponent,
  CardBackComponent,
  CardFrontComponent,
  SwitchComponent,
  EmptyStateComponent,
  ToastStackComponent,
  BrandLoaderComponent,
  ModalFrameComponent,
  ConfirmDialogComponent,
  LegalPanelComponent,
  ColorFieldComponent,
  ShapePickerComponent,
  DropzoneComponent,
  LogoPickerComponent,
  LocationMapComponent,
  BusinessPreviewComponent,
  NearbyCardComponent,
  ScheduleEditorComponent,
  SocialEditorComponent,
  LocationFieldsComponent,
  ProcessScreenComponent,
  UserMenuComponent,
  MapArtComponent,
  IdentityFieldsComponent,
  InactiveBannerComponent,
];

/** Design system propio de CradleRewards (componentes reutilizables de la consola). */
@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbDropdownModule, NgbModalModule, NgbOffcanvasModule, NgSelectModule, GoogleMap, MapAdvancedMarker],
  exports: [...COMPONENTS, CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbDropdownModule, NgbModalModule, NgbOffcanvasModule, NgSelectModule],
})
export class SharedModule {
  constructor() {
    // Textos de ng-select en español (todo campo de selección de la web usa ng-select).
    const config = inject(NgSelectConfig);
    config.notFoundText = 'Sin resultados';
    config.typeToSearchText = 'Escribe para buscar';
    config.loadingText = 'Cargando…';
    config.clearAllText = 'Quitar';
    config.addTagText = 'Agregar';
  }
}
